export default function PaperShell({ children }) {
  return (
    <>
      <style>{`
        /* ===== 화면 ===== */
        .paper {
          max-width: 210mm;
          margin: 16px auto;
          background: #fff;
          border: 1px solid #e5e7eb;
        }

        .paper-inner {
          padding: 10mm 10mm 10mm 10mm;
        }

        /* ===== 인쇄 ===== */
        @page {
          size: A4;
          margin: 0;
          margin-bottom : 10mm;
          margin-top: 5mm;
        }

        @media print {
        .print-avoid-break {
          page-break-inside: avoid;
          break-inside: avoid;
        }
        
          html, body {
            margin: 0 !important;
            padding: 0 !important;
            height: auto !important;
          }

          .print-bg {
            background-color: #f3f4f6 !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
            

          body {
            display: block !important;
          }
          .flex {
            height: auto !important;
          }
          .paper {
            margin: 0 !important;
            border: none !important;

            /* 🔥 핵심: 높이 / overflow 완전 제거 */
            height: auto !important;
            min-height: auto !important;
            overflow: visible !important;
          }

          .paper-inner {
            padding: 0 !important;
          }

          h1, h2, .text-title, .doc-header {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }


          .no-print {
            display: none !important;
          }
            .photo-cell {
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    background: transparent !important;
  }

  /* 설명/날짜 영역 제거 */
  .photo-meta {
    display: none !important;
  }

  /* 이미지 외 요소 제거 */
  .photo-cell button,
  .photo-cell span {
    display: none !important;
  }

  /* 이미지만 남기고 꽉 채우기 */
  .photo-image {
    width: 100% !important;
    height: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .photo-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
    page-break-inside: avoid;
  }

  .photo-board-grid {
    gap: 0 !important;
    background: transparent !important;
  }
            thead,
            th,
            .doc-thead,
            .doc-th,
            .doc-th-end {
              background-color: #f3f4f6 !important;
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
                  }
            .tbl-label-bg {
              background-color: #f3f4f6 !important; /* bg-gray-100 */
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
      `}</style>

      <div className="paper">
        <div className="paper-inner">{children}</div>
      </div>
    </>
  );
}
